import { AI_TIERS, getTierById } from "@/constants/aiTiersCatalog";

export const getTierRetailMidpoint = (tier) => {
  const info = getTierById(Number(tier));
  if (!info) return null;
  return Math.round((info.retailMin + info.retailMax) / 2);
};

export const formatMonthlyUsd = (amount) => {
  if (amount == null || Number.isNaN(Number(amount))) return "N/A";
  return `$${Number(amount).toLocaleString()}/mo`;
};

export const retailSourceLabel = (source) => (source === "custom" ? "Your price" : "Est.");

export const previewMargin = (tier, retailMonthlyUsd) => {
  const info = getTierById(Number(tier));
  if (!info || retailMonthlyUsd == null || Number.isNaN(Number(retailMonthlyUsd))) return null;
  return Number(retailMonthlyUsd) - info.wholesale;
};

export const sumActiveMargin = (clients) => {
  if (!Array.isArray(clients)) return 0;
  return clients.reduce((sum, client) => {
    if (client.status !== "active") return sum;
    return sum + (Number(client.marginMonthlyUsd) || 0);
  }, 0);
};

export const countActiveClients = (clients) => {
  if (!Array.isArray(clients)) return 0;
  return clients.filter((c) => c.status === "active").length;
};

export const mapApiRosterRow = (row) => ({
  id: row.id,
  name: row.name,
  email: row.email,
  vertical: (row.vertical || "").replace(/_/g, " "),
  tier: row.tier,
  creditsUsed: row.credits_used,
  creditsIncluded: row.credits_included,
  status: row.status,
  createdAt: row.created_at,
  lastActivityAt: row.last_activity_at,
  billingStopAt: row.billing_stop_at || null,
  partnerRetailMonthlyUsd: row.partner_retail_monthly_usd ?? null,
  retailMonthlyUsd: row.retail_monthly_usd,
  marginMonthlyUsd: row.margin_monthly_usd,
  retailSource: row.retail_source,
});

export const TIER_RETAIL_MIDPOINTS = AI_TIERS.reduce((acc, tier) => {
  acc[tier.id] = Math.round((tier.retailMin + tier.retailMax) / 2);
  return acc;
}, {});
